<template>
  <div class="content_box">
    <div class="feedback" id="ManageTable">
      <Adminstor v-if="userType == 1"></Adminstor>
      <User v-else></User>
    </div>
  </div>
</template>
<script>
import Adminstor from "./adminstor.vue";
import User from "./user.vue";
export default {
  data() {
    return {
      userType: 1,
    };
  },
  created() {
    this.getUserType();
  },
  methods: {
    getUserType() {
      console.log(sessionStorage.getItem("userType"));
      sessionStorage.getItem("userType") == "gly"
        ? (this.userType = 1)
        : (this.userType = 0);
    },
  },
  components: {
    Adminstor,
    User,
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.feedback {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
</style>